export const SITE_WORKING_CONDITION_MODULATION_TABLE_FRENCH_LOCALE = {
  headers: {
    hwId: "Modulateur Hw Id",
    csId: "Modulateur Cs Id",
    name: "Nom de l'appareil",
    status: "Statut modulation",
    modulationCount: "Nombre de modulation",
    modulationLevel: "Niveau",
    lastModulationDate: "Dernière modulation",
    linkCsId: "Link Cs Id",
    appliance: "Appareil",
    link: "Link",
    modulator: "Modulateur",
  },
  status: {
    NOT_TESTED: "Appareil: Conso faible",
    NOK: "Appareil: Échec de pilotage",
    OK: "Pilotage réussi",
  },
  modulationLevel: {
    NONE: "Aucune",
    LOW: "Faible",
    MEDIUM: "Normale",
    HIGH: "Élevé",
  },
  empty: "Aucun modulateur",
};
